import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import classnames from 'classnames';

import { Actions, Datagrid, List } from 'components/list';
import { ActionField } from 'components/fields';

import NameField from '../NameField';
import EditableNumberField from './EditableNumberField';
import DeleteLevelActionField from './DeleteLevelActionField';
import EditLevelActionField from './EditLevelActionField';
import AddLevelButton from './AddLevelButton';

const LevelActions = (props) => {
  return (
    <Actions {...props}>
      <AddLevelButton />
    </Actions>
  );
};

// Uses CSS counters since list context hooks aren't available in this RA version.
// Assumes each data row maps to one <tr> in the datagrid body.
const useStyles = makeStyles({
  levelsTable: {
    '& .datagrid-body': {
      counterReset: 'level-row',
    },
    '& .datagrid-body tr': {
      counterIncrement: 'level-row',
    },
  },
  rowNumber: {
    '&::before': {
      content: 'counter(level-row)',
    },
  },
});

const RowNumberField = ({ className, rowNumberClassName }) => (
  <Typography
    component="span"
    variant="body2"
    className={classnames(className, rowNumberClassName)}
  />
);

const Levels = (props) => {
  const classes = useStyles();

  return (
    <List
      {...props}
      resource="rewardsLevel"
      basePath="/rewardsSettings"
      pagination={false}
      actions={<LevelActions />}>
      <Datagrid className={classes.levelsTable}>
        <RowNumberField
          source="rowNumber"
          label="No."
          sortable={false}
          rowNumberClassName={classes.rowNumber}
        />
        <NameField source="name" imageSource="iconUrl" sortable={false} />
        <EditableNumberField source="minPoints" sortable={false} />
        <EditableNumberField source="minShipments" sortable={false} />
        <EditableNumberField source="minSpend" sortable={false} />
        <ActionField>
          <EditLevelActionField />
          <DeleteLevelActionField />
        </ActionField>
      </Datagrid>
    </List>
  );
};

export default Levels;
